/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ExpertWorkspaceExpertRole = 'Owner' | 'Admin' | 'Member';

export const ExpertWorkspaceExpertRole = {
    Owner: 'Owner' as ExpertWorkspaceExpertRole,
    Admin: 'Admin' as ExpertWorkspaceExpertRole,
    Member: 'Member' as ExpertWorkspaceExpertRole
};

